module.exports = __webpack_public_path__ + "media/images/product_owners/sml_airspace_mission_planning_90-10af50bb93afc784aec5590e018aa0f5.png";